// RN8b: fixed table of 15 group names — the 11 left-menu groups (named with
// the SAME i18n key the menu itself paints them with, LeftMenu.jsx) plus
// DG1-6/DP-1's four own groups, whose registry entries are not in the left
// menu at all so they carry their own key. Naming does NOT assign: which
// group a screen belongs to is decided by groupAssignment.js reading the
// registry, never by this table.
const GROUP_NAMES = {
  HOME: 'HOME',
  MONITORING: 'MONITORING',
  PLANNING: 'PLANNING',
  ORDERS: 'ORDERS',
  PROCESS: 'PROCESS',
  RESOURCES: 'RESOURCES',
  ANALYTICS: 'ANALYTICS',
  CONFIGURATION: 'CONFIGURATION',
  MAINTENANCE: 'MAINTENANCE',
  QUALITY: 'QUALITY',
  MOS: 'MOS',
  // The registry declares these two with addChildPermissionGroupRoute, whose
  // code is the path itself.
  '/quality': 'QUALITY',
  '/mos': 'MOS',
  '/header': 'Settings menu',
  '/cluster': 'Cluster',
  '/backoffice/proxiedServices': 'Backoffice',
  '/debug': 'Debug'
}

// B11: the order the impact shows the groups in — the side menu, then the
// four own groups — as the codes the analyzer emits (Quality and MOS come
// from the registry as '/quality' and '/mos'). The single source for the UI.
const GROUP_ORDER = [
  'HOME', 'MONITORING', 'PLANNING', 'ORDERS', 'PROCESS', 'RESOURCES', 'ANALYTICS', 'CONFIGURATION', 'MAINTENANCE',
  '/quality', '/mos',
  '/header', '/cluster', '/backoffice/proxiedServices', '/debug'
]

// S74: a registry code with no entry in this table is shown with its own
// code, never breaking the build — naming is best-effort, not a gate.
function nameOf (code) {
  const nameKey = GROUP_NAMES[code]
  if (nameKey === undefined) return { code, unnamed: true }
  return { nameKey, unnamed: false }
}

module.exports = { nameOf, GROUP_ORDER }
